var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0V0C43.464 0 56 12.536 56 28V28C56 43.464 43.464 56 28 56V56C12.536 56 0 43.464 0 28V28Z",
    fill: "#F9A825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5879 35.7887L24.3128 17.9597C25.9047 15.0413 30.0952 15.0413 31.6871 17.9597L41.412 35.7887C42.9386 38.5875 40.9129 41.9999 37.7249 41.9999H18.275C15.087 41.9999 13.0613 38.5875 14.5879 35.7887ZM27.9989 23.3204C28.5788 23.3204 29.0489 23.7905 29.0489 24.3704V31.3704C29.0489 31.9503 28.5788 32.4204 27.9989 32.4204C27.419 32.4204 26.9489 31.9503 26.9489 31.3704V24.3704C26.9489 23.7905 27.419 23.3204 27.9989 23.3204ZM27.9914 34.1704C27.2182 34.1704 26.5914 34.7972 26.5914 35.5704C26.5914 36.3436 27.2182 36.9704 27.9914 36.9704H28.004C28.7772 36.9704 29.404 36.3436 29.404 35.5704C29.404 34.7972 28.7772 34.1704 28.004 34.1704H27.9914Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/WarningCircle.bab2d9b2.svg";
export { ForwardRef as ReactComponent };